<script>
import { find } from 'lodash';

export default {
  name: 'SelectItems',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    itemText: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: undefined
    },
    itemDisabled: {
      type: Function,
      default: () => false
    },
    nullWhenEmpty: {
      type: Boolean,
      default: false
    },
    autoAdd: {
      type: Boolean,
      default: true
    },
    hideListIfEmpty: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: -1
    },
    trackBy: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      selectedItem: null,
      selectedItems: []
    };
  },
  computed: {
    itemsList () {
      return this.items.filter(item => {
        const predicate = {};
        predicate[this.trackBy] = item[this.trackBy];
        return !find(this.selectedItems, predicate);
      });
    },
    listEmpty () {
      return !this.items || this.items.length === 0;
    },
    allAdded () {
      return this.selectedItems.length >= this.maxItems;
    },
    maxItems () {
      return this.max !== -1 ? this.max : this.items.length;
    }
  },
  watch: {
    value (value) {
      this.selectedItems = value || [];
    },
    selectedItem (item) {
      if (this.autoAdd && item) {
        setTimeout(() => {
          this.addItem();
        });
      }
    }
  },
  created () {
    this.selectedItems = this.value || [];
  },
  methods: {
    addItem () {
      this.selectedItems.push(this.selectedItem);
      this.selectedItem = null;

      this.updateValue();
    },
    removeItem (item) {
      const index = this.selectedItems.indexOf(item);
      if (~index) {
        this.selectedItems.splice(index, 1);
      }

      this.updateValue();
    },
    updateValue () {
      if (this.nullWhenEmpty && this.selectedItems.length === 0) {
        this.$emit('input', null);
      } else {
        this.$emit('input', this.selectedItems);
      }
    }
  }
};
</script>

<template>
  <div class="select-items">
    <div class="list-label">
      {{ label }}
    </div>
    <v-list dense>
      <v-list-item-group>
        <v-list-item
          v-for="(item, i) in selectedItems"
          :key="i"
          inactive
        >
          <v-list-item-content>
            <slot
              name="selected-item-content"
              :item="item"
              :index="i"
            >
              {{ item[itemText] }}
            </slot>
          </v-list-item-content>
          <v-list-item-icon @click="removeItem(item)">
            <v-icon>
              mdi-close
            </v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-autocomplete
      v-if="!allAdded && !listEmpty"
      v-model="selectedItem"
      :items="itemsList"
      :item-text="itemText"
      label="Ajouter"
      return-object
      hide-selected
      hide-details
      :item-disabled="itemDisabled"
    >
      <template
        v-if="!autoAdd"
        v-slot:append-outer
      >
        <v-btn
          color="secondary"
          outlined
          :large="false"
          @click="addItem()"
        >
          Ajouter
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
    </v-autocomplete>
  </div>
</template>

<style lang="scss" scoped>
.v-list{
  background-color: #F4F8F9;
  // margin-top: -15px;
  padding: 0;
}

.select-items{
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 0;
  margin: 0.5em 0 0 0;

  .list-label{
    font-size: 0.8em;;
    color: rgba(0, 0, 0, 0.38);
    background-color: #F4F8F9;
    position: relative;
    top:-1em;
    left: 0.8em;
    padding: 0 0.3em;
    display: inline-block;

  }

  .v-list-item{
    margin: 0;
    padding: 0.3em 0.5em;;
    margin-top: -1em;
  }

  .v-autocomplete{
    margin: 0 0.5em 0.5em 0.5em!important;
  }
}
</style>
